import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

const rawBaseQuery = createBaseQuery('company_groups', { timeout: 0 });

const baseQuery = async (args, api, extraOptions) => {
  const response = await rawBaseQuery(args, api, extraOptions);
  if (response.error || !response.data?.error) return response;

  return { error: { status: response.data.status || 200, data: response.data } };
};

export const companyGroupsApi = createApi({
  reducerPath: 'companyGroupsApi',
  baseQuery,
  tagTypes: ['CompanyGroup'],
  endpoints: builder => ({
    getCompanyGroups: builder.query({
      query: () => '/',
      transformResponse: ({ result }) => result,
      providesTags: ['CompanyGroup'],
    }),
    getCompanyGroup: builder.query({
      query: id => `/${id}`,
      transformResponse: ({ result }) => result,
      providesTags: ['CompanyGroup'],
    }),
    createCompanyGroup: builder.mutation({
      query: body => ({
        url: '/',
        method: 'POST',
        body,
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: ['CompanyGroup'],
      async onQueryStarted(_body, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(companyGroupsApi.util.upsertQueryData('getCompanyGroup', data.id, data));
        } catch {
          return;
        }
      },
    }),
    updateCompanyGroup: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/${id}`,
        method: 'PUT',
        body,
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: ['CompanyGroup'],
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(companyGroupsApi.util.upsertQueryData('getCompanyGroup', id, data));
        } catch {
          return;
        }
      },
    }),
    deleteCompanyGroup: builder.mutation({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CompanyGroup'],
    }),
  }),
});

export const {
  useGetCompanyGroupsQuery,
  useGetCompanyGroupQuery,
  useCreateCompanyGroupMutation,
  useUpdateCompanyGroupMutation,
  useDeleteCompanyGroupMutation,
} = companyGroupsApi;
